import { AiOutlinePlus } from "react-icons/ai";
import { ITableRowData } from "../../../components/data-table/data-table";


import "./process-type-selector.scss";
import { failedToast } from "../../../../shared/utils/api";

interface IProcessTypeSelectorProps {
  processTypes: ITableRowData[];
  selectedProcessType: string | undefined;
  onSelectProcessType: (processType: ITableRowData) => void;
}

const ProcessTypeSelector = ({processTypes, selectedProcessType, onSelectProcessType}: IProcessTypeSelectorProps) => {
  const handleNewProcessTypeClicked = () => {
    if (processTypes.length > 0 && processTypes[processTypes.length - 1].id === "") {
      failedToast("Please save the current Process Type before making a new one.");
      return;
    }
    const newProcessType = {
      id: "",
      name: "New Process Type",
      active: true,
      process_type_stages: []
    };
    
    onSelectProcessType(newProcessType);
  };

  return <div className="processTypeSelector">
    <div className="processTypeSelector-processTypesTitle">
      <b>Process Types</b>
      <div className="processTypeSelector-processTypeAdd" onClick={handleNewProcessTypeClicked}><AiOutlinePlus /></div>
    </div>
    <div className="processTypeSelector-processTypesListWrapper">
      {processTypes.map((pt: ITableRowData) => (
        <div className={`processTypeSelector-processType ${selectedProcessType === pt.id ? "processTypeSelector-processTypeSelected" : "processTypeSelector-processTypeNotSelected"}`}
          onClick={() => onSelectProcessType(pt)} key={pt.id}>
          {pt.name}
        </div>
      ))}
    </div>
  </div>;
};

export default ProcessTypeSelector;